import RestService from "../../../service/RestService";

import $ from 'jquery';
import constants from 'Constants.js';
import { View } from 'backbone';
import Template from 'properties/table/column-main-dropdown.ejs';
import util from 'util/Util.js';
import PredefinedListsService from "../../../service/PredefinedListsService";
import PredefinedListsModal from 'common-views/PredefinedListsModalView.js';
import NotificationService from "../../../service/NotificationService";
import listService from "../../../service/ListService";

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';


class MainDropDownView extends View {
    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "change input[type=checkbox]" : "itemCheck",
            "change input[name='caption']" : "itemCaptionChange",
            "change input[name='value']" : "itemValueChange",
            "click .itemList" : "itemPredefinedList"
        };
        if (this.colId) {
            let factorykey = this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }



        this.columnModel.attributes['colModel'] = [
            {
                name: 'caption',
                index: 'caption',
                width: 100,
                editable: true
            },
            {
                name: 'value',
                index: 'value',
                width: 100,
                editable: true
            },
            {
                name: 'selected',
                index: 'selected',
                width: 100,
                edittype: 'checkbox',
                editoptions: { value:"selected" },
                formatter: "checkbox",
                formatoptions: { disabled: false}
            }
        ];

        this.columnModel.attributes['colNames'] = ['Caption', 'Value', 'Selected'];

        if (!this.model.get('gridData')[this.colId].attributes.gridData) {
            this.loadDataFromProperty();
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    loadDataFromProperty() {
        const prop = this.columnModel.get('Property');
        const captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        const values = _.find(prop, function(obj) { return obj._id === 'values' });

        if (!captions.Item) { captions.Item = []; }
        if (!values.Item) { values.Item = []; }


        const defaultValue = this.columnModel.get('defaultValue');
        let gridData = [];
        let selectionFound = false; // in case 2 entries have the same value, pick the first one.

        if (Array.isArray(captions.Item)) {
            for (var i = 0; i < captions.Item.length; i++) {

                let newRow = {
                    'caption': captions.Item[i]._value,
                    'value': values.Item[i]._value ,
                    'selected':  defaultValue === values.Item[i]._value && !selectionFound ? 'selected' : ''
                };

                selectionFound = (newRow.selected === 'selected');

                gridData.push(newRow);
            }
        } else {
            let newRow = {
                'caption': captions.Item._value,
                'value': values.Item._value ,
                'selected':  defaultValue === values.Item._value ? 'selected' : ''
            };

            gridData.push(newRow);

            // enforce array type
            const newItem = {_value: captions.Item._value};
            captions.Item = [newItem];

            const newValueItem = {_value: values.Item._value};
            values.Item = [newValueItem];
        }

        this.setGridData(gridData);
    }

    itemNew(){
        var gridData = this.getGridData();
        const newRowId = gridData.length + 1;
        var newRow = {
            'caption':'Item ' + (newRowId) ,
            'value': newRowId ,
            'selected':  ''
        };
        $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);



        let captions = _.find(this.columnModel.attributes.Property, function(obj) { return obj._id === 'captions' });
        let values = _.find(this.columnModel.attributes.Property, function(obj) { return obj._id === 'values' });

        captions.Item.push({ _value: 'Item ' + (newRowId) } );
        values.Item.push({ _value: newRowId } );


        gridData.push(newRow);
        this.columnModel.attributes['gridData'] = gridData;

        undoService.add({
            undo: () => {
                // Remove item
                gridData.splice(gridData.findIndex(e => e.caption === newRow.caption && e.value === newRow.value && e.selected === newRow.selected), 1);
                this.columnModel.attributes['gridData'] = gridData;

                this.render();
            },
            redo: () => {
                // Add same row
                gridData.push(newRow);
                this.columnModel.attributes['gridData'] = gridData;

                this.render();
            }
        }, textConstants.UNDO_MOVE);
    }

    itemRemove(){
        var gridData = this.getGridData();
        const rowid = this.getRowId();
        const prop = this.columnModel.get('Property');
        const itemRemoved = gridData[rowid];

        let captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        let values = _.find(prop, function(obj) { return obj._id === 'values' });

        //PF-10815 if the deleted element is the default value
        if(gridData[rowid].value === this.columnModel.get("defaultValue")){
            this.columnModel.unset("defaultValue");
        }

        captions.Item.splice(rowid,1);
        values.Item.splice(rowid,1);

        this.columnModel.set( gridData.splice(rowid, 1) );
        this.render();

        undoService.add({
            undo: () => {
                // Restore item
                gridData.splice(rowid, 0, itemRemoved);
                this.columnModel.attributes['gridData'] = gridData;
                this.render();
            },
            redo: () => {
                // Remove same item
                gridData.splice(gridData.findIndex(e => e.caption === itemRemoved.caption && e.value === itemRemoved.value && e.selected === itemRemoved.selected), 1);
                this.columnModel.attributes['gridData'] = gridData;
                this.render();
            }
        }, textConstants.UNDO_MOVE);
    }

    itemUp(){
        var gridData = this.getGridData();
        const rowid = this.getRowId();
        const prop = this.columnModel.get('Property');
        const captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        const values = _.find(prop, function(obj) { return obj._id === 'values' });

        if ( rowid > 0 ){
            gridData[rowid] = gridData.splice((rowid-1), 1, gridData[rowid])[0];
            captions.Item[rowid] = captions.Item.splice((rowid-1), 1, captions.Item[rowid])[0];
            values.Item[rowid] = values.Item.splice((rowid-1), 1, values.Item[rowid])[0];

            this.setRowId(rowid-1);
            this.setGridData(gridData);
            this.render();
        }

        undoService.add({
            undo: () => {    
                this.setRowId(rowid - 1);
                this.itemDown();     
            },
            redo: () => {
                this.setRowId(rowid);
                this.itemUp();  
            }
          }, textConstants.UNDO_MOVE);

    }

    itemDown(){
        var gridData = this.getGridData();
        var rowid = this.getRowId();
        const prop = this.columnModel.get('Property');
        const captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        const values = _.find(prop, function(obj) { return obj._id === 'values' });

        if ( rowid < ( gridData.length-1)){
            gridData[rowid] = gridData.splice((rowid+1), 1, gridData[rowid])[0];
            captions.Item[rowid] = captions.Item.splice((rowid+1), 1, captions.Item[rowid])[0];
            values.Item[rowid] = values.Item.splice((rowid+1), 1, values.Item[rowid])[0];

            this.setRowId(rowid+1);
            this.setGridData(gridData);
            console.log(gridData);
            this.render();
        }

        undoService.add({
            undo: () => {    
                this.setRowId(rowid + 1);
                this.itemUp();     
            },
            redo: () => {
                this.setRowId(rowid);
                this.itemDown();  
            }
          }, textConstants.UNDO_MOVE);

    }

    itemCheck(e){

        var i = $(e.currentTarget).closest('tr').index()-1;
        var gridData = this.getGridData();
        const checked = e.currentTarget.checked;
        var lastSelectedItemIndex = -1;

        gridData.forEach(function(value, index) {
            if (gridData[index].selected === 'selected'){
                lastSelectedItemIndex = index;
            }
            gridData[index].selected = '';
        });// reset out all

        if( checked ){
            gridData[i].selected = 'selected';
            this.columnModel.set('defaultValue', gridData[i].value);
        }else{
            this.columnModel.set('defaultValue', '');
        }

        this.setGridData(gridData);
        this.render();

        undoService.add({
            undo: () => {
                if (checked){
                    gridData.forEach(function(value, index) {
                        gridData[index].selected = '';
                    });// reset out all  
                    if(lastSelectedItemIndex >= 0){
                        gridData[lastSelectedItemIndex].selected = 'selected';
                        this.columnModel.set('defaultValue', gridData[lastSelectedItemIndex].value);
                    }
                }
        
                this.setGridData(gridData);
                this.render();
            },
            redo: () => {
                gridData.forEach(function(value, index) {
                    gridData[index].selected = '';
                });// reset out all
        
                if( checked ){
                    gridData[i].selected = 'selected';
                    this.columnModel.set('defaultValue', gridData[i].value);
                }

                this.setGridData(gridData);
                this.render();
            }
          }, textConstants.UNDO_MOVE);
    }

    itemCaptionChange(e){

        const index = $(e.currentTarget).closest('tr').index() - 1;
        var gridData = this.getGridData();
        const newVal = util.sanitizeHTML(e.currentTarget.value, true, gridData[index].caption);
        const oldVal = gridData[index].caption;

        gridData[index].caption = newVal;
        
        this.setGridData(gridData);

        undoService.add({
            undo: () => {      
                gridData[index].caption = oldVal;
        
                this.setGridData(gridData);
                this.render();
            },
            redo: () => {
                gridData[index].caption = newVal;

                this.setGridData(gridData);
                this.render();
            }
          }, textConstants.UNDO_MOVE);
    }

    itemValueChange(e){

        const index = $(e.currentTarget).closest('tr').index() - 1;
        var gridData = this.getGridData();
        const newVal = e.currentTarget.value;
        const oldVal = gridData[index].value;

        gridData[index].value = newVal;
        
        this.setGridData(gridData);

        undoService.add({
            undo: () => {      
                gridData[index].value = oldVal;
        
                this.setGridData(gridData);
                this.render();
            },
            redo: () => {
                gridData[index].value = newVal;

                this.setGridData(gridData);
                this.render();
            }
          }, textConstants.UNDO_MOVE);
    }

    saveCell(rowid, cellname, value){
        var gridData = this.getGridData();
        gridData[rowid][cellname] = util.sanitizeHTML(value, true, gridData[rowid][cellname]);
        this.setGridData(gridData);

        const prop = this.columnModel.get('Property');
        if (cellname === 'caption' ) {
            const captions = _.find(prop, function(obj) { return obj._id === 'captions' });
            captions.Item[rowid]._value = util.sanitizeHTML(value, true, captions.Item[rowid]._value);
        }

        if (cellname === 'value') {
            const values = _.find(prop, function(obj) { return obj._id === 'values' });
            values.Item[rowid]._value = util.sanitizeHTML(value, true, values.Item[rowid]._value);
        }

        this.render();
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        $("#" + iRow + "_" + cellName).on('blur', function () {
            $(self.gridEl).saveCell(iRow, iCol);
        });
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('#settings .ui-jqgrid-btable');
        let settingsWidth =  $('.settings-style-access').width() - 25;
        if (grid) {
            grid.each(function(index) {
                grid.setGridWidth(settingsWidth); 
            });
        }
    }

    setGridData(gridData) {
        this.model.get('gridData')[this.colId].attributes['gridData'] = gridData;
    }
    setCaption(gridData) {
        const props = this.model.get('gridData')[this.colId].attributes.Property;
        let captions = props.find(p => p._id === "captions");
        let values = props.find(p => p._id === "values");

        captions.Item = gridData.map(p => { return {_value: p.caption }});
        values.Item = gridData.map(p => { return {_value: p.value }});
    }
    setRowId(rowId) {
        this.model.get('gridData')[this.colId].attributes['rowid'] = rowId;
    }
    getRowId() {
        return Number(this.columnModel.attributes['rowid']);
    }
    getGridData() {
        return this.model.get('gridData')[this.colId].attributes.gridData;
    }

    itemPredefinedList(event){
        const predModal = new PredefinedListsModal({model: this.model});
        predModal.render().then((selected) => {
            let items;
            $(constants.PROP_MAIN_TABLE).clearGridData();
            const options =  {
                 'countries': () => {
                     items = PredefinedListsService.getCountries();
                     this.fillGrid(items);
                  },
                 'states': () => {
                     items = PredefinedListsService.getUSStates();
                     this.fillGrid(items);
                 },
                 'provinces': () => {
                    items = PredefinedListsService.getCanadianProvinces();
                    this.fillGrid(items);
                 },
                'default': () => {
                    this.fillListFromCustomList(selected)
                }
            }

            options[selected] ? options[selected]() :  options['default']();
        });
    }

    fillGrid(elements) {
        const gridData =  Object.keys(elements).map((key) => {
            return {
                'caption':elements[key] ,
                'value': key ,
                'selected':  ''
            };
        });

        this.setGridData(gridData);
        this.setCaption(gridData);
        this.render();
    }

    fillGridFromCustomList(elements) {
        const gridData = elements.map((list) => {
            return {
                'caption': list["@caption"] ,
                'value': list["@value"],
                'selected':  ''
            }
        });

        this.setGridData(gridData);
        this.setCaption(gridData);
        this.render();
    }

    fillListFromCustomList(selected) {
        RestService.getCustomList(selected).then((customLists) => {
            let customListsArray = customLists instanceof Array ? customLists : [customLists];
            this.fillGridFromCustomList(customListsArray);
        }).catch((err=>{
            console.log('Error retrieving custom list items ',err);
            NotificationService.error('Error retrieving custom list items '+err.MESSAGE);
        }));
    }

    render() {
        const gridData = this.getGridData();

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.get('gridData')[this.colId].toJSON()));
        }

        var colModel = this.model.get('gridData')[this.colId].attributes['colModel'];
        var colNames = this.model.get('gridData')[this.colId].attributes['colNames'];
        var self = this;
        $(self.gridEl).jqGrid({
            datatype: "local",
            autowidth: true, 
            autoencode: true,
            shrinkToFit: true,
            height: 110,
            altRows: true,
            cellEdit: true,
            cellsubmit : 'clientArray',
            gridComplete: function() {
                $("tr.jqgrow:odd").css("background", "#DDDDDC");
            },

            //jsonReader : {root: this.model.get('rows') },
            colNames: colNames,
            colModel: colModel,
            beforeSelectRow: function (rowid) {
                self.setRowId(rowid);
            },
            afterSaveCell: function (rowid, cellname, value) {
                self.saveCell(rowid, cellname, value);
            }, 
            afterEditCell: function (rowId, cellName, value, iRow, iCol) {
                self.afterEditCell(rowId, cellName, value, iRow, iCol);
            },
            resizeStop: function(width, index) {
                let columns = $(self.gridEl).jqGrid ('getGridParam', 'colModel');
                let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                if ($("#gbox_propMainTable").width() < colWidth) {
                    $(self.gridEl).closest('.ui-jqgrid-bdiv')
                        .css('overflow', '')
                        .addClass('format-table-overflow-shown');
                }
            }
        });

        //PF-9041, remove all rows first to avoid duplicating the rows
        $(self.gridEl).jqGrid('clearGridData');

        gridData.forEach(function(value, index) {
            $(self.gridEl).addRowData(index, value);
        });

        this.resizeGrid();
        this.delegateEvents();

        return this;
    }
}

export default MainDropDownView;
